import React, { Component } from 'react';

import VisibilitySensor from 'react-visibility-sensor';
import { makeSafe } from '../../services/cloudinaryService';
import PlayButton from '../../layout/graphics/PlayButton';
import VolumeControl from './VolumeControl';
// import RewindIcon from '../../layout/graphics/RewindIcon';


class VideoPart extends Component {

  constructor(props) {
    super(props);
    this.state = {
      paused: true,
      muted: true,
    };
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.restart = this.restart.bind(this);
    this.playIfPaused = this.playIfPaused.bind(this);
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this); // registers component on parent through callback
    }
  }

  playIfPaused() {
    if (this.video.paused) {
      this.setState({
        paused: false
      });
      this.video.play().catch(() => {});
    }
  }

  restart() {
    this.video.currentTime = 0;
    this.playIfPaused();
  }

  togglePlay() {
    if (this.video.paused) {
      this.setState({
        paused: false
      });
      this.video.play();
    } else {
      this.setState({
        paused: true
      });
      this.video.pause();
    }
  }

  toggleMuted() {
    if (this.video.muted) {
      this.setState({
        muted: false
      });
      this.video.muted = false;
    } else {
      this.setState({
        muted: true
      });
      this.video.muted = true;
    }
  }

  handleVisibilityChange(visible) {
    this.setState({
      paused: !visible
    });
    if (visible) this.video.play();
    else this.video.pause();
  }

  render() {
    const { videoUrl, fallbackImage, fallBackAlt, track, autoplay = false } = this.props;
    return (
      <div className="c-card-banner c-video-player">

        <button
          className={`c-card-banner_play-btn ${this.state.paused ? 'paused' : ''}`}
          onClick={() => this.togglePlay()}
          aria-label={this.state.paused ? 'Play video' : 'Pause video'}
        >
          {
            <PlayButton />
          }
        </button>

        <VisibilitySensor
          onChange={autoplay ? this.handleVisibilityChange : false}
          offset={{ left: -200, right: -200 }}
        >

          <video
            ref={(video) => { this.video = video; }}
            loop
            playsInline
            preload="none"
            muted
            onClick={() => this.togglePlay()}
          >

            <source src={makeSafe(videoUrl)} type="video/mp4" />
            <track kind="descriptions" srcLang="en" src={track} />

            {
              fallbackImage ?
                <img
                  src={makeSafe(fallbackImage)}
                  width="1600"
                  height=""
                  alt={fallBackAlt || ''}
                  title="No video playback capabilities, please download"
                /> : null
            }

          </video>
        </VisibilitySensor>

        <div className="c-video-player__controls u-padding-tiny u-w-100 u-flex u-flex-align-items-center u-flex-justify-end u-border-box">

          {/* <button
            className="u-clickable-link"
            onClick={() => this.restart()}
          >
            <RewindIcon />
          </button> */}

          <button
            className="u-clickable-link"
            onClick={() => this.toggleMuted()}
            aria-label={this.state.muted ? 'Unmute video' : 'Mute video'}
          >
            <VolumeControl muted={this.state.muted} />
          </button>

        </div>

      </div>
    );
  }
}

export default VideoPart;



// WEBPACK FOOTER //
// ./src/parts/VideoPart/index.js